<template>
  <div class="banner"></div>
</template>

<script>
export default {
  name: 'Banner'
}
</script>

<style lang="scss" src="../assets/scss/banner.scss" scoped></style>
